import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Checkbox, Button, Row, Col } from 'antd';
import { Link } from 'react-router-dom';

import { password_recovery } from 'constants/routes';
import { postLogin } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';

const validationSchema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
});

@withAutoFocusForm
@withAsyncActions({
    formAction: postLogin.withSuccessHandler(()=> console.log('saf'))
}, { resetOnMount: true })
@withForm({
    validationSchema: validationSchema,
})
export default class LoginForm extends Component {
 
    render() {

        return (
            <div className="promo-form">
                <Field
                    name='username'
                    component={Input}
                    placeholder='E-mail'
                />
                <Field
                    name='password'
                    type='password'
                    component={Input}
                    placeholder='Пароль'
                />
                <Row className="form-row">
                    <Col xs={14}>
                        <Checkbox>Запомнить меня</Checkbox>
                    </Col>
                    <Col className="text-right" xs={10}>
                        <Link className="link-control" to={password_recovery.path}>
                            Забыл пароль
                        </Link>
                    </Col>
                </Row>
                <Row className="form-row m-b-20">
                    <Button type='primary' size='large' htmlType='submit'>
                        Войти
                    </Button>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/LoginForm.js